var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"disabled":_vm.disabled || !_vm.company,"name":_vm.$t('orderForm.type'),"options":_vm.typeOptions,"required":"","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }